import React, {Component} from 'react';
import {connect, dispatch} from 'react-redux';
import {bindActionCreators} from 'redux';
import Typekit from 'react-typekit';

import {fetchPosts, ROUTER} from '../actions/index';

import Header from '../components/header';
import WalkingTourFrameTest from '../components/walkingtour-frame-test';
import Footer from '../components/footer';
import NavBar from './parts/NavBar';

class WalkingTourTest extends Component {
		
    componentDidUpdate() {
        document.title = `${RT_API.siteName} - ${RT_API.siteDescription}`;
    }

    render() {
        return (
            <section className="kiosk-wrapper">
                <Typekit kitId="eab1tpm" />
                <Header/>
                <WalkingTourFrameTest/>
				<NavBar name="footer_menu" />
            </section>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({fetchPosts, dispatch}), dispatch)
}

export default connect(null, mapDispatchToProps)(WalkingTourTest)


// WEBPACK FOOTER //
// ./src/containers/walkingtourtest.js